/**
 * @auth 赖传峰
 * @date 2021/12/15 11:04
 */
import type {
  CSSProperties,
  StyleValue,
} from 'vue'
import { type PropType } from '#imports'

const propsType = {
  size: {
    type: Number,
    default: 24,
  },
  color: {
    type: String as PropType<CSSProperties['color']>,
    default: 'var(--color-secondary-text)',
  },
  hoverColor: {
    type: String as PropType<CSSProperties['color']>,
    default: 'var(--color-primary)',
  },
  style: {
    type: Object as PropType<StyleValue>,
    default: {},
  },
  spin: {
    type: Boolean,
    default: false,
  },
  hoverAble: {
    type: Boolean,
    default: false,
  },
  pointer: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
}

export default propsType
